module.exports = __webpack_public_path__ + "static/media/siddharth-big-banyan-tree-trip-03.e5817047.png";